import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-caja-lista',
  templateUrl: './lista.component.html'
})

export class ListaComponent{
  tamano;
  status = 1;
  ngOnInit() {
    this.tamano = document.body.clientHeight;
  }
}
